import { render } from "./PwaMeaasage.vue?vue&type=template&id=37c5e554&lang=pug"
import script from "./PwaMeaasage.vue?vue&type=script&lang=js"
export * from "./PwaMeaasage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__